<div class="p-10 flex flex-column content-evenly radius-10" [class.bg-gray]="value == null || value === ''" style="border: solid 1px #DCEEFF; min-height: 95px;">
    <p class="text-center no-margin text-xs dark-gray" style="min-height: 28px;">{{categoryTitle}}</p>
    <p class="text-center no-margin text-lg dark-blue" style="min-height: 23.5px;">{{value}}</p>
    <p class="text-center no-margin text-xs dark-gray" style="min-height: 13.5px;">
        <span *ngIf="note">({{note}})</span>
    </p>
</div>